import React from 'react'

const Resetpass = () => {
  return (
    <div>We have sent your a link to your email to reset Your Password</div>
  )
}

export default Resetpass